import { AIUsageDashboard } from '@/components/admin/ai-usage/AIUsageDashboard';

export default function AdminAIUsagePage() {
  return (
    <div className="container mx-auto max-w-7xl py-8">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">AI Usage & Analytics</h1>
        <p className="text-muted-foreground mt-2">
          Monitor token usage, costs, and cache efficiency for AI conversations
        </p>
      </div>
      <AIUsageDashboard />
    </div>
  );
}
